import(/* webpackMode: "eager" */ "/app/hub/src/app/template.tsx");
